export default __webpack_public_path__ + "static/media/West Cleave of the White Tiger.44cfd1be.jpg";